<template>
    <div>
        <multiselect
            v-model="selectedOptions"
            :options="options"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :placeholder="placeholder"
            track-by="id"
            label="name"
            :show-labels="false"
        ></multiselect>
        <div v-if="inputName">
            <input
                v-for="option in selectedOptions"
                :key="option.id"
                type="hidden"
                :name="inputName + '[]'"
                :value="option.id"
            >
        </div>
    </div>
</template>

<script>
import Multiselect from '../../lib/vue-multiselect/';

export default {
    name: 'LogisticMultiCompanySelect',
    components: { Multiselect },
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        initialSelectedIds: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'Select…',
        },
        inputName: {
            type: String,
            default: 'additional_subscription_ids',
        },
    },
    data() {
        return {
            selectedOptions: [],
        };
    },
    mounted() {
        const initialIds = this.initialSelectedIds.map((id) => Number(id));
        this.selectedOptions = this.options.filter((opt) => initialIds.indexOf(Number(opt.id)) !== -1);
    },
    watch: {
        selectedOptions(newValue) {
            this.$emit('input', newValue.map((opt) => opt.id));
        },
    },
};
</script>
